module.exports = "\r\n<router-outlet></router-outlet>\r\n<!-- <div *ngIf=\"chart\">\r\n    <canvas id=\"canvas\">{{ chart }}</canvas>\r\n  </div> -->"


//////////////////
// WEBPACK FOOTER
// ./src/app/app.component.html
// module id = ./src/app/app.component.html
// module chunks = main